var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"be-btn-languages",on:{"click":function($event){return _vm.$bvModal.show('language-modal')}}},[_c('img',{staticClass:"be-btn-languages__icon",attrs:{"src":_vm.lang.icon,"alt":_vm.lang.title}}),_c('span',{staticClass:"be-btn-languages__text"},[_vm._v(_vm._s(_vm.lang.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }